import React from 'react';
import Button from './CustomButtons/Button';
import ButtonSpinner from './ButtonSpinner';
import { Color } from '../util/interfaces';
import { dialogStyles } from '../styles/dialogStyles';

export interface DialogActionsProps {
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
  disabled?: boolean;
  t: (key: string) => string;
  confirmText?: string;
  cancelText?: string;
  confirmColor?: Color;
  cancelColor?: Color;
}

const defaultProps = {
  confirmText: 'appointment.dialog.btn.ok',
  cancelText: 'appointment.dialog.btn.no',
  confirmColor: Color.primary,
  cancelColor: 'danger' as const
};

const DialogActions: React.FC<DialogActionsProps> = ({
  onClose,
  onConfirm,
  loading,
  disabled,
  t,
  confirmText = defaultProps.confirmText,
  cancelText = defaultProps.cancelText,
  confirmColor = defaultProps.confirmColor,
  cancelColor = defaultProps.cancelColor
}) => (
  <div style={dialogStyles.actions}>
    <Button onClick={onClose} color={cancelColor}>
      {t(cancelText)}
    </Button>
    <ButtonSpinner
      id="button-accept"
      onClick={onConfirm}
      label={t(confirmText)}
      labelLoading={t(confirmText)}
      loading={loading}
      typeButton="submit"
      color={confirmColor}
      disabled={loading ?? disabled}
    />
  </div>
);

export default DialogActions; 